import PlanOfCare from './PlanOfCare';

export default PlanOfCare;
